<template>
    <div class="rounded-full p-5 mt-3 font-poppins text-center w-72 h-72 flex flex-col justify-center items-center border-2 border-teal-500">
        <p class="font-bold text-xl">Antrean Anda</p>
        <p class="font-bold text-5xl text-teal-300 mt-2">{{ statusAntrianData.antrianPasien }}</p>
        <p class="text-md mt-5">Dilayani: {{ statusAntrianData.antrianPanggil }}</p>
        <p class="text-md">Sisa: {{ statusAntrianData.antrianSisa }}</p>
    </div>
    <div class="font-poppins mt-5">
        <p class="font-sm">data diperbaharui pada : <span class="text-red-500">{{ timerCount }}</span></p>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
export default {
    data(){
        return {
            timerCount: 10,
            statusAntrianData: this.statusAntrian
        }
    },  
    methods: {
        getStatusAntrian(){
            this.$inertia.get(
                "/status_antrian/ajax/"+this.statusAntrian.encBookAntrian,
                {
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.statusAntrianData = page.props.additional.statusAntrian;
                        this.timerCount = 10;
                    },
                }
            );
        }
    },
    watch: {
        timerCount:{
            handler(value){
                if(value > 0){
                    setTimeout(()=>{
                        this.timerCount--;
                    },1000);
                }else{
                    this.getStatusAntrian();
                }
            },
            immediate: true 
        }
    },  
    props: {
        statusAntrian: Object,
    },
    components: {
        Link,
    },
};
</script>
